import { render, staticRenderFns } from "./warehouse-outputs.vue?vue&type=template&id=c951b38c&scoped=true"
import script from "./warehouse-outputs.vue?vue&type=script&lang=js"
export * from "./warehouse-outputs.vue?vue&type=script&lang=js"
import style0 from "./warehouse-outputs.vue?vue&type=style&index=0&id=c951b38c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c951b38c",
  null
  
)

export default component.exports